import React, { Component } from 'react';
import CalculatorRegularPayment from './CalculatorRegularPayment';
import ContCalculatorCriteriaSvcLevels from '../../containers/ContCalculatorCriteriaSvcLevels';
import CalculatorContentCommon from './CalculatorContentCommon';

class CalculatorContentSvcLevels extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="row p-1 m-1">
                    <div className="col-lg-8">
                        <ContCalculatorCriteriaSvcLevels
                            isCalculationResult={this.props.isCalculationResult}
                            calculationResponse={this.props.calculationResponse} />
                    </div>
                    <div className="col-lg-4">
                        <div className="p-1 m-1">
                            <div className="shadow rounded p-2 m-1 text-center">
                                <CalculatorRegularPayment
                                    context={this.props.context}
                                    amountNature={this.props.amountNature}
                                    isCalculationResult={this.props.isCalculationResult}
                                    calculationResponse={this.props.calculationResponse}
                                    onUpdateCriteria={this.props.onUpdateCriteria}
                                />
                            </div>
                        </div>
                        {this.props.isCalculationResult
                            && this.props.calculationResponse.result.globalText
                            && this.props.calculationResponse.result.globalText.financialProductLabel
                            && <div className="p-1 m-1">
                                <div className="shadow rounded p-2 m-1 text-center">
                                    <h5>
                                        {this.props.calculationResponse.result.globalText.financialProductLabel.text}
                                    </h5>
                                </div>
                            </div>
                        }
                        <div className="p-1 m-1">
                            {CalculatorContentCommon.renderDisplayBlocks(this.props.isCalculationResult, this.props.calculationResponse)}
                        </div>
                    </div>
                </div>
                <CalculatorContentCommon isCalculationResult={this.props.isCalculationResult} calculationResponse={this.props.calculationResponse}
                />
            </React.Fragment>
        );
    }
}

export default (CalculatorContentSvcLevels)
